<script>
import App from '@/pages/layouts/app.vue';
import {Link} from "@inertiajs/vue3";
import Card from "@/pages/components/card.vue";
import Datatable from "@wielink-application/shared/js/mixins/datatable";

export default {
  mixins: [Datatable],
  components: {
    Card,
    App,
    Link
  },
  props: {
    tableConfig: {
      type: String,
      required: true,
    }
  },
  // mounted() {
  //   this.$nextTick(() => {
  //     new Table({
  //       scope: this.$refs.table
  //     })
  //   });
  // }
}
</script>

<template>
  <App title="Klanten">
    <template #topButtons>
      <Link :href="route('customers.create')" class="btn btn-primary">
        <i class="bi bi-plus-lg"></i>
          Klant toevoegen
      </Link>
    </template>

    <Card>
        <Table id="customers" ref="table" :config="tableConfig" />
    </Card>
  </App>
</template>